import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EditorService {

constructor(private http: HttpClient) { }

addEditorContent(editordata: any) {
  return this.http.post<any>(environment.apiUrl + 'PageEditor/add', editordata);
}

getEditorContent(page: string) {
  return this.http.get<any>(environment.apiUrl + 'PageEditor/get/' + page);
}

updateEditorContent(editordata: any) {
  return this.http.post<any>(environment.apiUrl + 'PageEditor/update', editordata);
}
}
